import { useTranslation } from 'react-i18next';

import { senzaDestinazione, type LimuloAzionePendente } from '@/lib/limulo/azionePersistente';
import { presentazioneDi, titoloAzioneOf } from '@/lib/limulo/presentazione';
import { useGetLimuloTournamentQuery } from '@/services/limuloApi';

/**
 * Il titolo di una riga e se e' INERTE (senza destinazione: la sfida di piattaforma): la lettura del torneo e la presentazione, UNA sola volta per tutte le righe (la riga di oggi e quella della
 * v3 la usano entrambe: la logica non si copia). Era nel corpo di `RigaAzione`.
 */
export function useTitoloAzione(azione: LimuloAzionePendente): { titolo: string; inerte: boolean } {
  const { t } = useTranslation('limulo');
  const inerte = senzaDestinazione(azione);
  // r15: una partita di coda non dice «Round» (v. `titoloAzioneOf`). L'`origine` la porta la voce del motore (qlash-limulo#216,
  // kb#368 p.3): quando c'e' si decide da li' e NON si fa nessuna lettura per riga. Solo se la voce non la porta (server
  // precedente alla #216, un valore non pubblico, le righe che non nascono dal motore) si ripiega sul dettaglio del torneo:
  // una lettura per torneo, dalla stessa voce di cache (RTK la condivide fra le righe e con le altre schermate). Una riga senza
  // destinazione (la sfida di piattaforma) non ha un torneo da leggere. Finche' non arriva: il titolo di oggi.
  const origineDellaVoce = typeof azione.origine === 'string' ? azione.origine : null;
  const { currentData: torneoLetto } = useGetLimuloTournamentQuery(azione.tournamentId, {
    skip: inerte || origineDellaVoce !== null,
  });
  const presentazione =
    origineDellaVoce !== null
      ? presentazioneDi(azione.tournamentId, { origine: origineDellaVoce })
      : torneoLetto
        ? presentazioneDi(azione.tournamentId, torneoLetto)
        : null;
  const titolo = titoloAzioneOf(azione, presentazione, (torneo, round) => t('persistente.titolo', { torneo, round }));
  return { titolo, inerte };
}

